import React from 'react';

export const ItemListIcon = ({
  width = 24,
  height = 24,
  color = '#F3F3F5',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.9071 19.5999C21.1618 19.6184 21.4022 19.7247 21.5872 19.9007L27.3067 25.3448C27.8716 25.8824 27.8827 26.7798 27.3312 27.3313C26.7798 27.8827 25.8824 27.8716 25.3448 27.3067L19.9202 21.6077C19.7343 21.4123 19.6305 21.1529 19.6305 20.8832V20.4544C19.6305 20.1531 19.4247 19.8907 19.1321 19.819C18.9264 19.7686 18.7114 19.8219 18.5486 19.9531C16.9722 21.2229 14.9722 21.98 12.8053 21.98C7.738 21.98 3.63054 17.8726 3.63054 12.8053C3.63054 7.73801 7.738 3.63056 12.8053 3.63056C17.8725 3.63056 21.98 7.73801 21.98 12.8053C21.98 15.015 21.1926 17.0512 19.8772 18.6415C19.7937 18.7425 19.7458 18.8694 19.7458 19.0018C19.7458 19.2916 19.9696 19.5322 20.2587 19.5531L20.9071 19.5999ZM6.32661 12.8053C6.32661 16.3901 9.22049 19.2839 12.8053 19.2839C16.3901 19.2839 19.2839 16.3901 19.2839 12.8053C19.2839 9.22051 16.3901 6.32663 12.8053 6.32663C9.22049 6.32663 6.32661 9.22051 6.32661 12.8053ZM12.0929 15.2837C11.3889 15.7871 10.4491 15.0836 10.721 14.2545C10.8611 13.8272 10.706 13.3539 10.3363 13.0965C9.63798 12.6103 9.98201 11.5142 10.8329 11.5142H10.8754C11.3207 11.5142 11.7158 11.2287 11.8557 10.8059L11.8844 10.7191C12.1642 9.87302 13.361 9.87302 13.6408 10.7191L13.67 10.8075C13.8096 11.2296 14.2077 11.5142 14.6517 11.5142C15.5102 11.5142 15.8663 12.6175 15.1676 13.105C14.7942 13.3655 14.6383 13.8426 14.7838 14.2737C15.0589 15.0893 14.13 15.7826 13.4321 15.2836L13.3774 15.2445C13.0097 14.9816 12.5155 14.9816 12.1478 15.2445L12.0929 15.2837Z"
      fill={color}
      stroke="#1E1E22"
      strokeWidth="0.15"
    />
  </svg>
);
